module.exports = __webpack_public_path__ + "img/blog.715afd9d.png";